checkDOMListeners